var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-full-width', {
    attrs: {
      "showFooter": false,
      "isProgressDone": true
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        var _vm$report, _vm$report2, _vm$report3, _vm$report4, _vm$report5, _vm$report6, _vm$report7, _vm$report8;

        return [_vm.loading ? _c('v-card', {
          staticClass: "mx-4  mt-4",
          attrs: {
            "flat": "",
            "outlined": ""
          }
        }, [_c('v-skeleton-loader', {
          staticClass: "ma-4",
          attrs: {
            "type": "title, paragraph, paragraph"
          }
        })], 1) : !_vm.loading && _vm.sharedContent ? _c('v-row', {
          staticClass: "fore-ground",
          attrs: {
            "dense": "",
            "no-gutters": "",
            "justify": "center"
          }
        }, [_c('v-col', {
          staticClass: "order-1",
          attrs: {
            "cols": "12",
            "md": "12",
            "lg": "3"
          }
        }, [_c('shared-content-access-description', {
          attrs: {
            "partner": _vm.partner,
            "user": _vm.user,
            "sharedContent": _vm.sharedContent,
            "report": _vm.report
          }
        }), _vm.report && _vm.report.vehicle ? _c('shared-content-vehicle-card', {
          attrs: {
            "vehicle": _vm.report.vehicle
          }
        }) : _vm._e(), _vm.sharedContent && _vm.sharedContent.contacts && _vm.sharedContent.contacts.length ? _c('shared-content-contact-card', {
          attrs: {
            "contacts": _vm.sharedContent.contacts
          }
        }) : _vm._e()], 1), _c('v-col', {
          staticClass: "order-3 order-md-2",
          attrs: {
            "cols": "12",
            "md": "8",
            "lg": "6"
          }
        }, [_vm.isCompleted ? _c('div', [_c('v-img', {
          staticClass: "ma-2",
          attrs: {
            "contain": "",
            "src": require("@/assets/undraw_checklist__re_2w7v.svg"),
            "height": "240",
            "justify": "center"
          }
        }), _c('v-row', {
          staticClass: "ma-2"
        }, [_c('v-spacer'), _c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemDocument.completed")) + " ")]), _c('v-spacer')], 1)], 1) : _c('v-timeline', {
          staticClass: "mx-4 mb-8",
          attrs: {
            "dense": "",
            "clipped": ""
          }
        }, [_vm.report && _vm.report.status ? _c('v-card', {
          staticClass: "mb-6",
          attrs: {
            "flat": "",
            "dark": "",
            "outlined": "",
            "color": _vm.color
          }
        }, [_c('v-card-text', {
          staticClass: "pl-0 py-0",
          class: _vm.report.statusHistory ? 'mb-n2' : ''
        }, [_c('v-timeline', {
          staticClass: "white--text",
          attrs: {
            "dense": "",
            "clipped": "",
            "align-top": ""
          }
        }, [_c('v-timeline-item', {
          attrs: {
            "color": _vm.color,
            "small": "",
            "icon": "mdi-information"
          }
        }, [_c('v-row', [_c('v-col', [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$t("common.nouns.status")) + ": " + _vm._s(_vm.report.status) + " ")]), _c('v-spacer'), _vm.report.statusHistory && _vm.report.statusHistory.length > 1 && !_vm.isExpand ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function click($event) {
              _vm.isExpand = true;
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-chevron-down")])], 1) : _vm.isExpand ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function click($event) {
              _vm.isExpand = false;
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-close")])], 1) : _vm._e()], 1)])], 1)], 1)], 1)], 1), _vm.isExpand && _vm.report.statusHistory && _vm.report.statusHistory.length ? _c('v-card-text', {
          staticClass: "pl-0 py-0"
        }, [_c('v-timeline', {
          staticClass: "white--text",
          attrs: {
            "dark": "",
            "dense": "",
            "clipped": "",
            "align-top": ""
          }
        }, _vm._l(_vm.report.statusHistory.slice().reverse(), function (status, i) {
          return _c('v-timeline-item', {
            key: i,
            attrs: {
              "small": "",
              "fill-dot": "",
              "color": "white"
            }
          }, [_c('v-row', [_c('v-col', {
            attrs: {
              "cols": "12",
              "md": "8"
            }
          }, [_c('div', {
            staticClass: "text-subtitle-2"
          }, [_c('span', {
            staticClass: "d-inline d-md-none"
          }, [_vm._v(_vm._s(_vm._f("detailedDate")(new Date(status.created))) + ":"), _c('br')]), _c('span', [_vm._v(" " + _vm._s(status.status))])]), status.message ? _c('div', {
            staticClass: "text-body-2"
          }, [_vm._v(" " + _vm._s(status.message) + " ")]) : _vm._e()]), _c('v-col', {
            staticClass: "d-none d-md-flex",
            attrs: {
              "cols": "12",
              "md": "4"
            }
          }, [_c('div', {
            staticClass: "text-body-2 text-right"
          }, [_c('span', [_vm._v(" " + _vm._s(_vm._f("detailedDate")(new Date(status.created))))])])])], 1)], 1);
        }), 1)], 1) : _vm._e()], 1) : _vm._e(), _vm.showSubmitData ? _c('timeline-card', {
          attrs: {
            "title": _vm.$t('report.request.title')
          }
        }, [_c('v-card', {
          attrs: {
            "flat": ""
          }
        }, [_c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.$t("report.request.description")) + " ")]), _c('v-card-actions', [_c('v-btn', {
          attrs: {
            "loading": _vm.loading,
            "block": "",
            "x-large": "",
            "color": "primary"
          },
          on: {
            "click": _vm.startAttachmentRequest
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("report.request.action")) + " ")])], 1)], 1)], 1) : _vm._e(), _vm.signRequests && _vm.signRequests.length ? _c('timeline-card', {
          attrs: {
            "title": _vm.$t('sign.SignForm.title')
          }
        }, [_vm._l(_vm.signRequests, function (signRequest) {
          return [_c('v-card', {
            key: 'sr' + signRequest.requestId,
            attrs: {
              "flat": ""
            }
          }, [_c('v-card-title', [_vm._v(" " + _vm._s(signRequest.title) + " ")]), signRequest.description ? _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.summarizeDescription(signRequest.description)) + " ")]) : _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.$t("sign.Sign.description", {
            companyName: _vm.companyName
          })) + " ")]), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "loading": _vm.loading,
              "block": "",
              "x-large": "",
              "color": "primary"
            },
            on: {
              "click": function click($event) {
                return _vm.startSignRequest(signRequest.requestId);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm.$t("sign.SignForm.proceedToDocument")) + " ")])], 1)], 1)];
        })], 2) : _vm._e(), _vm._l(_vm.sharedDocuments, function (sharedDocument) {
          return _c('div', {
            key: "".concat(sharedDocument.refId, "-").concat(sharedDocument.refType)
          }, [sharedDocument.refType === _vm.ResourceEnum.REPORT && sharedDocument.refDocument ? _c('report-base-time-line', {
            attrs: {
              "report": sharedDocument.refDocument,
              "color": _vm.color,
              "hideEmptyImages": true
            }
          }) : sharedDocument.refType === _vm.ResourceEnum.DOCUMENT && sharedDocument.refDocument ? _c('activity-time-line-item-document-card', {
            attrs: {
              "isLoading": false,
              "document": sharedDocument.refDocument
            }
          }) : sharedDocument.refType === _vm.FrontendResourceEnum.SIGNED && sharedDocument.refDocument ? _c('activity-time-line-item-signed-card', {
            attrs: {
              "flat": "",
              "document": sharedDocument.refDocument
            }
          }) : sharedDocument.refType === _vm.ResourceEnum.SNAPSHOT && sharedDocument.refDocument ? _c('v-card', {
            attrs: {
              "flat": ""
            }
          }, [_c('snapshot-detail', {
            attrs: {
              "value": sharedDocument.refDocument,
              "hideBreadCrumbs": true,
              "hideToDetailButton": true,
              "hideShareButton": true,
              "hideSignButton": true,
              "outline": true
            }
          })], 1) : sharedDocument.refType === _vm.ResourceEnum.REPAIR_ESTIMATE && sharedDocument.refDocument ? _c('repair-estimate-response-card', {
            staticClass: "mb-6",
            attrs: {
              "value": sharedDocument.refDocument,
              "token": _vm.accessToken
            }
          }) : sharedDocument.refType === _vm.ResourceEnum.CLEARANCE_APPROVAL && sharedDocument.refDocument ? _c('clearance-approval-response-card', {
            staticClass: "mb-6",
            attrs: {
              "value": sharedDocument.refDocument,
              "token": _vm.accessToken
            }
          }) : sharedDocument.refType === _vm.ResourceEnum.CLEARANCE && sharedDocument.refDocument ? _c('clearance-response-card', {
            staticClass: "mb-6",
            attrs: {
              "value": sharedDocument.refDocument,
              "token": _vm.accessToken
            }
          }) : sharedDocument.refType === _vm.ResourceEnum.APPRAISAL && sharedDocument.refDocument ? _c('appraisal-response-card', {
            staticClass: "mb-6",
            attrs: {
              "value": sharedDocument.refDocument,
              "token": _vm.accessToken
            }
          }) : sharedDocument.refType === _vm.ResourceEnum.RENTAL && sharedDocument.refDocument ? _c('rental-response-card', {
            staticClass: "mb-6",
            attrs: {
              "value": sharedDocument.refDocument,
              "token": _vm.accessToken
            }
          }) : _vm._e()], 1);
        }), !_vm.hidePrint ? _c('div', [_c('v-timeline-item', {
          staticClass: "no-print",
          attrs: {
            "hide-dot": ""
          }
        }), _c('tooltip', {
          staticClass: "no-print",
          attrs: {
            "text": _vm.$t('views.PartnerSharedReport.printHint')
          }
        }, [_c('v-btn', {
          staticClass: "no-print",
          attrs: {
            "elevation": "0",
            "color": "info"
          },
          on: {
            "click": _vm.print
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("views.PartnerSharedReport.print")) + " "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-printer-outline")])], 1)], 1)], 1) : _vm._e()], 2)], 1), _c('v-col', {
          staticClass: "order-2 order-md-3",
          attrs: {
            "cols": "12",
            "md": "4",
            "lg": "3"
          }
        }, [_c('span', [_vm.report ? _c('v-card', {
          staticClass: "mx-4 mt-6",
          attrs: {
            "flat": "",
            "outlined": ""
          }
        }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("common.nouns.damage")) + " ")]), _c('v-card-text', [_c('v-row', {
          attrs: {
            "dense": ""
          }
        }, [(_vm$report = _vm.report) !== null && _vm$report !== void 0 && _vm$report.claimNumber ? _c('v-col', {
          attrs: {
            "cols": (_vm$report2 = _vm.report) !== null && _vm$report2 !== void 0 && _vm$report2.externalId ? 6 : 12
          }
        }, [(_vm$report3 = _vm.report) !== null && _vm$report3 !== void 0 && _vm$report3.claimNumber ? _c('m-text-field', {
          attrs: {
            "label": _vm.$t('objects.report.claimNumber'),
            "value": _vm.report.claimNumber,
            "readonly": "",
            "hide-details": ""
          }
        }) : _vm._e()], 1) : _vm._e(), (_vm$report4 = _vm.report) !== null && _vm$report4 !== void 0 && _vm$report4.externalId ? _c('v-col', {
          attrs: {
            "cols": "6"
          }
        }, [_c('m-text-field', {
          attrs: {
            "label": _vm.$t('objects.report.externalId'),
            "value": _vm.report.externalId,
            "readonly": "",
            "hide-details": ""
          }
        })], 1) : _vm._e()], 1), _c('v-row', {
          attrs: {
            "dense": ""
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_vm.report.coverageType ? _c('m-select', {
          attrs: {
            "label": _vm.$t('objects.report.coverageType'),
            "readonly": true,
            "items": _vm.coverageTypeItems,
            "append-icon": '',
            "hide-details": ""
          },
          model: {
            value: _vm.report.coverageType,
            callback: function callback($$v) {
              _vm.$set(_vm.report, "coverageType", $$v);
            },
            expression: "report.coverageType"
          }
        }) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()], 1), !_vm.loading && _vm.sharedContent ? _c('span', [_vm.report && _vm.report.location ? _c('v-card', {
          staticClass: "mx-4  mt-6",
          attrs: {
            "flat": "",
            "outlined": ""
          }
        }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("report.currentLocation.title")) + " ")]), _c('v-card-text', {
          staticClass: "pa-0"
        }, [_c('partner-report-map-address', {
          model: {
            value: _vm.report.location,
            callback: function callback($$v) {
              _vm.$set(_vm.report, "location", $$v);
            },
            expression: "report.location"
          }
        })], 1)], 1) : _vm._e(), (_vm$report5 = _vm.report) !== null && _vm$report5 !== void 0 && _vm$report5.workShopCompany || (_vm$report6 = _vm.report) !== null && _vm$report6 !== void 0 && _vm$report6.repair ? _c('span', [_c('v-card', {
          staticClass: "mx-4  mt-6",
          attrs: {
            "flat": "",
            "outlined": ""
          }
        }, [(_vm$report7 = _vm.report) !== null && _vm$report7 !== void 0 && _vm$report7.workShopCompany ? _c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportSelectWorkshopCard.title")) + " ")]) : _vm._e(), (_vm$report8 = _vm.report) !== null && _vm$report8 !== void 0 && _vm$report8.workShopCompany ? _c('v-card-text', {
          staticClass: "pa-0"
        }, [_c('company-sheet', {
          attrs: {
            "company": _vm.report.workShopCompany
          }
        })], 1) : _vm._e(), _vm.report.repair ? _c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("objects.report.repair.title")) + " ")]) : _vm._e(), _vm.report.repair ? _c('v-card-text', [_c('partner-report-repair-info', {
          attrs: {
            "report": _vm.report,
            "showPeriod": false
          }
        })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm.showTowing ? _c('v-card', {
          staticClass: "mx-4 mt-6",
          attrs: {
            "flat": "",
            "outlined": ""
          }
        }, [_c('partner-report-towing-card', {
          attrs: {
            "report": _vm.report,
            "hideCompanyDetails": true
          }
        })], 1) : _vm._e()], 1) : _vm._e()])], 1) : !_vm.loading && _vm.isExpired ? _c('v-row', {
          staticClass: "fore-ground",
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('shared-content-access-expired', {
          attrs: {
            "partner": _vm.partner
          }
        })], 1)], 1) : !_vm.loading && _vm.isThrottled ? _c('v-row', {
          staticClass: "fore-ground",
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('v-img', {
          staticClass: "mt-8",
          attrs: {
            "contain": "",
            "src": require("@/assets/undraw/undraw_qa_engineers.svg"),
            "height": "240",
            "justify": "center"
          }
        }), _c('v-row', [_c('v-spacer'), _c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("sign.Sign.error.tooManyRequests")) + " ")]), _c('v-spacer')], 1)], 1)], 1) : !_vm.loading && !_vm.sharedContent ? _c('v-row', {
          staticClass: "fore-ground",
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('v-img', {
          staticClass: "mt-8",
          attrs: {
            "contain": "",
            "src": require("@/assets/undraw/undraw_qa_engineers.svg"),
            "height": "240",
            "justify": "center"
          }
        }), _c('v-row', [_c('v-spacer'), _c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("sign.Sign.error.404")) + " ")]), _c('v-spacer')], 1)], 1)], 1) : _vm._e()];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }